import styled from 'styled-components'

export const StarWidgetContainer = styled.div`
  position: absolute;
  top: -25px;
  left: calc(100vw - 370px);
  @media (max-width: 1440px) {
    top: -20px;
    right: 10.8vw;
  }
  @media (max-width: 1200px) {
    top: 0;
    left: calc(100vw - 250px);
  }
`

export const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
  .innerWidget {
    @media (max-width: 850px) {
      position: absolute;
      right: -35px;
    }
  }
  .descriptionSection {
    display: flex;
    justify-content: space-between;
    margin-bottom: 60px;
    width: 100%;
    .entries {
      flex-wrap: nowrap;
      @media (max-width: 1000px) {
        max-height: 240px;
        flex-wrap: wrap;
        :nth-child(2) {
          margin-bottom: 61px;
        }
      }
      @media (max-width: 600px) {
        max-height: unset;
        :nth-child(2) {
          margin-bottom: 0;
        }
      }
    }
    .tags {
      @media (max-width: 600px) {
        margin-bottom: 30px;
      }
    }
    @media (max-width: 1000px) {
      flex-wrap: wrap;
      flex-direction: row;
    }
    @media (max-width: 600px) {
      margin-bottom: 0;
    }
  }
  .descriptionLink {
    max-width: 86vw;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .descriptionAside {
    @media (min-width: 1001px) {
      width: 627px;
      .widget {
        width: auto;
      }
    }
  }
  
  .embedContentWrapper {
    max-width: 540px;  
    padding-right: 80px;
    margin: 35px 0;
    
    @media (max-width: 1000px) {
      padding: 0 60px;
      max-width: inherit;
    }
    
    @media (max-width: 600px) {
      padding: 0 20px;
    }
  }
  
  .widget {
    margin-top: 105px;
    margin-bottom: 35px;
    @media (max-width: 1320px) {
      left: calc(100vw - 410px);
    }
    @media (max-width: 1170px) {
      left: calc(100vw - 315px);
    }
    @media (max-width: 1000px) {
      position: unset;
      width: 100vw;
      border-radius: 0;
      margin-top: 40px;
    }
    @media (max-width: 600px) {
      margin-top: 11px;
    }
    .innerDiv {
      @media (max-width: 1200px) {
        padding-left: 50px;
      }
      @media (max-width: 768px) {
        padding: 55px 0 0 0;
        margin-left: 50px;
      }
      @media (max-width: 600px) {
        margin-left: 20px;
      }
    }
  }
  
  .widget + .widget {
    margin-top: 35px;
  }
  
  .widget--donation {
    .innerDiv {
      padding-top: 46px;
      padding-bottom: 46px;
    }
    .header {
      display: inline-flex;
      align-items: center;
      
      svg {
        padding-right: 15px;
      }
    }
    .entries {
      max-width: 470px;
      margin-top: 5px;
      font-size: 14px;
      line-height: 1.57;
      letter-spacing: normal;
    }
  }
  
  .donationLink {
    display: block;
    color: inherit;
    text-decoration: none;
  }
`

export const LocationDiv = styled.div`
  display: flex;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 2px;
  flex-direction: column;
  max-height: 118px;
  .timeEntry {
    display: flex;
  }
  .star {
    :hover {
      fill: #933EC5;
    }
    fill: #fff;
    transition: fill .4s ease;
    width: 30px;
    height: 30px;
    margin-right: 19px;
    @media (max-width: 600px) {
      width: 25px;
      height: 25px;
    }
  }
  button {
    background: none;
    border: none;
    outline: none;
    padding: 0;
    cursor: pointer;
  }
  :not(:last-child) {
    margin-bottom: 20px;
  }
  :last-child {
    margin-bottom: 61px;
  }
  @media (max-width: 768px) {
    margin-bottom: 46px;
    margin-top: 0;
  }
  
  .schedule {
    display: flex;
    flex-direction: column;
    margin-left: 5px;
  }
  
  .timeHeader {
    font-family: StolzlMedium, serif;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.5;
  }
  
  .locationLink {
    text-decoration: none;
    font-size: 20px;
    max-width: 420px;
    //white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    font-weight: 300;
    line-height: 1.5;
    color: #080707;
    cursor: pointer;
    margin-left: 49px;
    :hover {
      color: #933EC5;
    }
    @media (max-width: 1000px) {
      max-width: 60vw;
    }
  }
`
